(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.invDate = DateUtils.convertLocalDateFromServer(data.invDate);
                        data.invDueDate = DateUtils.convertLocalDateFromServer(data.invDueDate);
                        data.estPayment = DateUtils.convertLocalDateFromServer(data.estPayment);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.invDate = DateUtils.convertLocalDateToServer(data.invDate);
                    data.invDueDate = DateUtils.convertLocalDateToServer(data.invDueDate);
                    data.estPayment = DateUtils.convertLocalDateToServer(data.estPayment);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.invDate = DateUtils.convertLocalDateToServer(data.invDate);
                    data.invDueDate = DateUtils.convertLocalDateToServer(data.invDueDate);
                    data.estPayment = DateUtils.convertLocalDateToServer(data.estPayment);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
